import React, { useRef } from 'react';
var VeltCommentsSidebarV2FilterDropdownContentListItem = function (props) {
    var item = props.item, group = props.group, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-list-item-v2", { ref: ref, item: item ? (typeof item === 'object' ? JSON.stringify(item) : item) : undefined, group: group ? (typeof group === 'object' ? JSON.stringify(group) : group) : undefined }, children));
};
export default VeltCommentsSidebarV2FilterDropdownContentListItem;
